import { Phone, ArrowRight, CheckCircle2 } from "lucide-react";
import { contactInfo } from "@/data/content";

const badges = ["Kotikäynnit & etätuki", "Selkokielistä opastusta", "Kotitalousvähennys"];

export const Hero = () => {
  return (
    <section id="hero" className="relative overflow-hidden bg-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-16 sm:py-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="fade-up">
          <span className="inline-block bg-[#E8C88A]/40 text-[#245037] font-bold text-base px-4 py-2 rounded-full mb-6">
            Henkilökohtaista digitukea
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#1C1917] leading-[1.1]">
            Teknologia tutuksi helposti ja selkeästi
          </h1>
          <p className="mt-6 text-lg sm:text-xl leading-relaxed text-[#44403C] max-w-xl">
            Digilaitteiden käyttö voi tuntua vaikealta – mutta ei enää. Digivili
            auttaa sinua rauhassa ja ystävällisesti, jotta digimaailma avautuu
            selkeästi ja vaivattomasti.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="#yhteys"
              data-testid="hero-cta-contact"
              className="inline-flex items-center justify-center gap-2 bg-[#245037] text-white hover:bg-[#1A3B28] rounded-xl px-8 py-4 text-lg font-bold transition-transform active:scale-95"
            >
              Ota yhteyttä <ArrowRight strokeWidth={2.5} className="w-5 h-5" />
            </a>
            <a
              href={contactInfo.phoneHref}
              data-testid="hero-cta-call"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#1C1917] hover:bg-[#F3EFE7] rounded-xl px-8 py-4 text-lg font-bold border-2 border-[#D6D3D1] transition-transform active:scale-95"
            >
              <Phone strokeWidth={2.5} className="w-5 h-5" /> Soita {contactInfo.phone}
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {badges.map((b) => (
              <span key={b} className="flex items-center gap-2 text-base font-semibold text-[#44403C]">
                <CheckCircle2 strokeWidth={2.5} className="w-5 h-5 text-[#245037]" /> {b}
              </span>
            ))}
          </div>
        </div>

        <div className="fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative">
            <div className="absolute -inset-4 bg-[#E8C88A]/30 rounded-[2rem] -rotate-2" />
            <img
              src="https://images.unsplash.com/photo-1758612898691-afe3e1d08a0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
              alt="Iloinen seniori käyttää tietokonetta kotona"
              className="relative rounded-[2rem] shadow-lg w-full h-[420px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
